import { socialIconsData } from "./Icons/socialIconsData";

export const resources = {
  currentSkills: [
    "Semantic & accessible HTML",
    "Responsive Web Design",
    "Teamwork",
    "Markdown",
    "Immutability",
    "CSS BEM convention",
    "CSS Grid",
    "CSS Flexbox",
    "React Router",
    "Redux-Saga",
    "Redux (Toolkit)",
    "React Hooks",
    "Error handling",
    "Working with API (fetch, axios)",
    "JavaScript: ES6+",
    "Promises, Async/Await",
    "Trello",
    "GitHub Pull Requests & Review",
    "Scrum",
    "NPM",
    "React",
    "Git",
  ],
  futureSkills: [
    "React Context",
    "Node.js",
    "Cypress",
    "Unit testing",
    "TypeScript",
    "JS classes",
  ],
  name: "Maksim Padrabinkin",
  email: "maxfadet@gmail.com",
  githubAPI: "https://api.github.com/users/maxFadet/repos",
  socialIcons: socialIconsData,
};